import { render, staticRenderFns } from "./ListCards.vue?vue&type=template&id=3cc0b5d6&scoped=true"
import script from "./ListCards.vue?vue&type=script&lang=ts"
export * from "./ListCards.vue?vue&type=script&lang=ts"
import style0 from "./ListCards.vue?vue&type=style&index=0&id=3cc0b5d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc0b5d6",
  null
  
)

export default component.exports